module.exports = __webpack_public_path__ + "static/media/chatbot.83da7975.png";